import React, { Component } from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';

class Checkbox extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
      const {colData,id,header,storageSelectionMode} = this.props;
      if (storageSelectionMode === true && colData && (colData.hide === true || colData.hidden === true)) {
        return (
          <td
            key={"column"+id}
            className={(colData.cellClassName) ? colData.cellClassName : 'ship-storage-td-check'}
            style={{ minWidth: '20px', width: '44px', textAlign: 'center', padding: '8px 6px' }}
          />
        );
      }
      const eventsHandler = storageSelectionMode === true ? {
        onChange: (event) => {
          if (event && event.stopPropagation) {
            event.stopPropagation();
          }
          if (colData.changeHandler) {
            colData.changeHandler(colData, colData.attributes);
          }
        },
        onClick: (event) => {
          if (event && event.stopPropagation) {
            event.stopPropagation();
          }
        }
      } : {
        onChange:() => (colData.changeHandler) ?
                colData.changeHandler(colData,colData.attributes):
                      'javascript(void)'
      };
      const isStorageCheck = storageSelectionMode === true
        && colData.attributes
        && colData.attributes.className
        && String(colData.attributes.className).indexOf('ship-storage-file-check') !== -1;
      const cellClassName = isStorageCheck
        ? 'ship-storage-td-check'
        : 'position-relative';
      const cellStyle = isStorageCheck
        ? { minWidth: '44px', width: '44px', textAlign: 'center', padding: '8px 6px', verticalAlign: 'middle' }
        : { minWidth: '20px', paddingLeft: '19px' };
        return(
            <td key={"column"+id} style={cellStyle} className={cellClassName}>
                <input 
                    {...eventsHandler}
                    {...(header.attributes)?{ ...header.attributes}:{}} 
                    {...colData.attributes}
                    className={(storageSelectionMode === true && colData.attributes && colData.attributes.className)
                        ? colData.attributes.className
                        : 'form-radio-input'}
                    type="checkbox" 
                    checked={(colData.checked===true)?true:false}
                    disabled={storageSelectionMode === true && colData.disabled === true}
                    name="checkbbox" value="" style={(storageSelectionMode === true && colData.attributes && colData.attributes.style)
                        ? colData.attributes.style
                        : (isStorageCheck ? undefined : {"top":"0px"})}></input>
            </td>
        );
    }
}

Checkbox.defaultProps = {
    storageSelectionMode: false
};

export default Checkbox;
